import { $elementChild, $elementChildren } from "@grindex-common/helpers/elements";

const MOBILE_BREAKPOINT = 1024;
const ACTIVE_CLASS = "active";

function init([$view]) {
	// TODO: Atlas possibly change this check to something more robust
	const isNewUi = document.body.classList.contains("newui");
	const $menuColumns = $elementChildren($view, "menu-column");
	const $menuOpeners = $elementChildren($view, "menu-opener");
	const $menuBacks = $elementChildren($view, "menu-back");

	function adjustPositions() {
		if (window.innerWidth > MOBILE_BREAKPOINT) {
			$menuColumns.forEach(($menuColumn) => {
				const $menuItems = $elementChildren($menuColumn, "menu-items");

				if ($menuItems.length > 0) {
					const $columnSubLinks = $elementChild($menuColumn, "menu-sub-links");
					$columnSubLinks.style.left = "-42px";
					const position = $menuItems[$menuItems.length - 1].getBoundingClientRect();

					if (position.right > window.innerWidth) {
						$columnSubLinks.style.left = "-" + (position.right - window.innerWidth + 90) + "px";
					}
				}
			});
		}
	}

	if (!isNewUi) {
		$menuOpeners.forEach(($menuOpener) =>
			$menuOpener.addEventListener("click", (event) => {
				if ("ontouchstart" in document.documentElement || window.innerWidth < MOBILE_BREAKPOINT) {
					event.preventDefault();
				}

				const $parent = event.target.parentElement;

				if (!$parent.classList.contains(ACTIVE_CLASS)) {
					$menuColumns.forEach(($menuColumn) => $menuColumn.classList.remove(ACTIVE_CLASS));
				}

				$parent.classList.toggle(ACTIVE_CLASS);
				$view.classList.toggle(ACTIVE_CLASS);
			}),
		);

		$menuBacks.forEach(($menuBack) =>
			$menuBack.addEventListener("click", () => {
				$view.classList.remove(ACTIVE_CLASS);
				$menuColumns.forEach(($menuSubLink) => $menuSubLink.classList.remove(ACTIVE_CLASS));
			}),
		);

		window.addEventListener("resize", adjustPositions);
		adjustPositions();
	}
}

export default {
	view: "mega-menu",
	init,
};
